import { render } from "./skulist.vue?vue&type=template&id=4855a2be"
import script from "./skulist.vue?vue&type=script&lang=js"
export * from "./skulist.vue?vue&type=script&lang=js"

import "./skulist.vue?vue&type=style&index=0&id=4855a2be&lang=less"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__